import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import { RRule, RRuleSet, rrulestr } from 'rrule';
import { HttpClient } from '@angular/common/http';
import {TransportRepeat} from '../../model/Entities/TransportRepeat';
import {UserService} from '../../services/user.service';
import {Filter} from '../../model/Helpers/Filter';
import {User} from '../../model/Entities/User';
import {environment} from '../../environments/environment';


@Component({
    selector: 'transport-repeat-dialog',
    templateUrl: './transportRepeat.dialog.component.html',
})

export class TransportRepeatDialogComponent {
    public readonly RRule = RRule;


    addresses: any;
    search: string = '';



    ruleSetting = {
        freq: RRule.WEEKLY,
        interval: 1,
        dtstart: new Date(),
        byweekday: [],
        until: null
    }

    transportRepeat: TransportRepeat;
    users: User[];




    constructor(public dialog: MatDialogRef<TransportRepeatDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private userService: UserService,
                private http: HttpClient) {

        this.transportRepeat = data.transportRepeat;

        if (this.transportRepeat.id) {
            // this.decodeRule();
        } else {
            this.generateRule();
        }
        this.loadUsers();
    }

    loadUsers() {
        const ignore = this.transportRepeat.users.map(u => u.id);

        this.userService.getSimpleList(
            [
                new Filter('search', this.search),
            ],
            { expand: 'role' }
        ).subscribe((data: User[]) => {
            data = data.filter(u => ignore.indexOf(u.id) === -1);
            // seřadit řidiče nahoru
            data.sort((a: User, b: User) => {
                if (a.role.name === 'driver' && b.role.name !== 'driver') {
                    return -1;
                } else if (a.role.name !== 'driver' && b.role.name === 'driver') {
                    return 1;
                }
                return a.name.localeCompare(b.name);
            });
            this.users = data;
        });
    }

    changeMonth() {
        if (this.ruleSetting.freq != RRule.WEEKLY) {
            this.ruleSetting.byweekday = [];
        }
    }

    setByWeekDay(rruleDay) {
        if (this.ruleSetting.byweekday.includes(rruleDay)) {
            this.ruleSetting.byweekday = this.ruleSetting.byweekday.filter(item => item !== rruleDay);
        } else {
            this.ruleSetting.byweekday.push(rruleDay);
        }
        console.log(this.ruleSetting.byweekday);
        this.generateRule();
    }

    selectAddress(address) {
        if (address.zip === undefined) {
            address.zip = '';
        }
        this.transportRepeat.address = address.name + ', ' + address.zip + ', ' + address.location;
        this.transportRepeat.addressLat = address.position.lat;
        this.transportRepeat.addressLon = address.position.lon;
    }

    driverSelect(driver) {
        this.transportRepeat.users.push(driver);
        this.loadUsers();
    }

    removeDriver(driver) {
        this.transportRepeat.users = this.transportRepeat.users.filter(u => u.id !== driver.id);
    }

    searchDriver($event: KeyboardEvent) {
        this.search = $event.target['value'];
        this.loadUsers();
    }

    searchAddress($event: KeyboardEvent) {
        const search = $event.target['value'];
        this.loadAddresses(search);
    }

    loadAddresses(search: string) {
        if (!search || search.length < 3) {
            this.addresses = [];
            return;
        }

        const apiKey = environment.apiMapyCom;
        const url = `https://api.mapy.com/v1/suggest?query=${encodeURIComponent(search)}&type=regional.address,poi&apiKey=${apiKey}`;

        this.http.get<any>(url).subscribe(
            (response) => {
                this.addresses = response.items || [];
            },
            (error) => {
                console.error("Nepodařilo se načíst adresy:", error);
                this.addresses = [];
            }
        );
    }

    generateRule() {
        const rule = new RRule(this.ruleSetting);
        this.transportRepeat.rrule = rule.toString();
        // console.log(rule.all());
    }

    // decodeRule() {
    //     if (!this.transportRepeat.rrule) {
    //         return;
    //     }
    //
    //     const rruleString = this.transportRepeat.rrule.replace(/DTSTART:(\d{8}T\d{6}Z)RRULE:/, 'DTSTART:$1\nRRULE:');
    //     const rule = rrulestr(rruleString) as RRule;
    //
    //     console.log(rule);
    //
    //     this.ruleSetting.freq = this.rruleGetConstantByNumber(rule.options.freq);
    //     this.ruleSetting.interval = rule.options.interval;
    //     this.ruleSetting.dtstart = rule.options.dtstart || new Date();
    //     this.ruleSetting.byweekday = this.decodeByWeekDay(rule.options.byweekday);
    //     this.ruleSetting.until = rule.options.until || null;
    //     console.log(this.ruleSetting);
    // }

    rruleGetConstantByNumber(value: number) {
        return RRule[Object.keys(RRule).find(
            key => RRule[key] === value && typeof RRule[key] === "number")];
    }

    decodeByWeekDay(value) {
        if (!value) {
            return [];
        }
        value.forEach(val => {
            this.setByWeekDay(this.rruleGetConstantByNumber(val));
        });

        return this.ruleSetting.byweekday;
    }

    checkValidity() {
        if (!this.transportRepeat.title) {
            return false;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// /app/src/TransportModule/TransportRepeatDialogComponent/transportRepeat.dialog.component.ts